/**
 * Chart series palettes. Slot order is fixed: series N always gets slot N,
 * never a cycled or generated hue. The default is the brand-neutral light
 * palette from the dataviz reference (validated for colour-vision deficiency
 * on a #fcfcfb surface). A house palette can be added as another entry.
 */
export interface ChartPalette {
  id: string
  label: string
  /** Series colours in slot order, 8 entries. */
  series: string[]
  /** Chart surface the palette was validated against. */
  surface: string
}

export const DEFAULT_PALETTE_ID = "default"

export const CHART_PALETTES: Record<string, ChartPalette> = {
  default: {
    id: "default",
    label: "Default",
    series: [
      "#2a78d6", "#eb6834", "#1baf7a", "#eda100",
      "#e87ba4", "#008300", "#4a3aa7", "#e34948",
    ],
    surface: "#fcfcfb",
  },
}

/** Colours for `count` series. Beyond 8 the caller must fold into "Other". */
export const paletteColours = (id: string | undefined, count: number): string[] => {
  const palette = CHART_PALETTES[id ?? DEFAULT_PALETTE_ID] ?? CHART_PALETTES.default
  return palette.series.slice(0, Math.max(0, Math.min(count, palette.series.length)))
}
